export default "__VITE_ASSET__Bu5jFE_B__"